import { render } from "./react_button.vue?vue&type=template&id=65cb031c"
import script from "./react_button.js?vue&type=script&lang=js"
export * from "./react_button.js?vue&type=script&lang=js"

import "./react_button.vue?vue&type=style&index=0&id=65cb031c&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__